import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Warranty(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, sx, viewBox, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Warranty", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M23.6235 45.6748c.3.075.525.075.825 0 3-.9 8.1-2.85 12.45-7.65 8.7-9.6 7.575-22.5 6.975-26.55-.075-.675-.6-1.125-1.2-1.275-2.325-.37499-5.1-1.125-8.1-2.25-4.05-1.575-7.275-3.6-9.6-5.4-.525-.375-1.275-.375-1.8 0-2.325 1.725-5.55 3.75-9.6 5.4-3 1.20001-5.77503 1.87501-8.10003 2.25-.6.075-1.125.6-1.2 1.275-.6 4.05-1.725 16.95 6.97503 26.55 4.275 4.8 9.375 6.825 12.375 7.65Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M24.4504 40.4252c-.3.075-.6.075-.9 0-2.775-.975-6.15-2.7-9.075-5.925-5.69996-6.225-6.37495-14.475-6.14995-19.35 0-.675.525-1.275 1.2-1.425 1.94995-.45 3.82495-1.05 5.69995-1.8 2.85-1.125 5.55-2.475 8.1-4.125.45-.3 1.05-.3 1.575 0 2.55 1.65 5.25 3 8.1 4.125 1.875.75 3.75 1.35 5.7 1.8.675.15 1.125.75 1.2 1.425.225 4.95-.45 13.125-6.15 19.35-3.15 3.225-6.525 4.95-9.3 5.925Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "m16.2 23.625.975-.975c.6-.675 1.65-.675 2.25 0l2.55 2.625c.6.675 1.65.675 2.25 0l7.35-7.5c.6-.675 1.65-.675 2.25 0l.975.975c.6.675.6 1.65 0 2.325L24.225 31.8c-.6.675-1.65.675-2.25 0L16.2 25.95c-.6-.675-.6-1.725 0-2.325Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M21 10.5c-5.1.9-5.85 1.65-6.75 6.75-.9-5.1-1.65-5.85-6.75-6.75 5.1-.9 5.85-1.65 6.75-6.75.9 5.1 1.65 5.85 6.75 6.75Zm23.25 27c-5.1.9-5.85 1.65-6.75 6.75-.9-5.1-1.65-5.85-6.75-6.75 5.1-.9 5.85-1.65 6.75-6.75.9 5.1 1.65 5.85 6.75 6.75Z",
        fill: theme.vars.palette.secondary.main
      }
    )
  ] });
}
Warranty.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Warranty"
};
validateTidalLicense();
export {
  Warranty
};
//# sourceMappingURL=Warranty.js.map
